{
  "rk.datepicker.clear": "Clear",
  "rk.datepicker.confirm": "OK",
  "rk.datepicker.selectDate": "Select date",
  "rk.datepicker.selectRange": "Select date range",
  "rk.datepicker.time": "Time",
  "rk.error.unknown": "Unknown error.",
  "rk.json.tableAria": "JSON data table",
  "rk.multiSelect.noOptions": "No options found.",
  "rk.multiSelect.select": "Select...",
  "rk.multiSelect.selected": "{{count}} selected",
  "rk.print.action": "Print",
  "rk.print.all": "Print all data",
  "rk.print.options.confirm": "Print",
  "rk.print.options.title": "Print options",
  "rk.print.selected": "Print selected",
  "rk.print.sheet.title": "{{resource}} — printout",
  "rk.print.tooManyRows": "Too many rows to print (over {{limit}}). Narrow the list first.",
  "rk.print.window.blocked": "Your browser blocked the print window. Allow pop-ups for this site, then print again.",
  "rk.print.window.hint": "Before printing, turn off \"Headers and footers\" and keep \"Margins\" on \"Default\" — this sheet sets its own paper margins.",
  "rk.print.window.preparing": "Preparing the printout…",
  "rk.query.addFilter": "Add filter",
  "rk.query.cancel": "Cancel",
  "rk.query.clearSearch": "Clear search",
  "rk.query.removeFilter": "Remove filter",
  "rk.query.searchChip": "Search: {{term}}",
  "rk.query.searchChipTitle": "Click to edit the search term: {{term}}",
  "rk.query.searchPlaceholder": "Search by keyword",
  "rk.query.selectMultiple": "Select multiple...",
  "rk.resource.actionCompleted": "Action completed",
  "rk.resource.actionFailed": "{{name}} Failed",
  "rk.resource.conditionsMerged": "Several filters on the same field ({{fields}}) were combined into one — the list below matches the combined condition.",
  "rk.resource.conditionsOverridden": "Several filters on the same field ({{fields}}) cannot be combined, so only the last one is applied — the list below ignores the earlier ones.",
  "rk.resource.confirmProceed": "Are you sure you want to proceed?",
  "rk.resource.create": "Create {{name}}",
  "rk.resource.createTitle": "Create {{name}}",
  "rk.resource.created": "Created",
  "rk.resource.createdSuccess": "{{name}} created successfully",
  "rk.resource.creating": "Creating...",
  "rk.resource.deleteConfirmMessage": "Are you sure you want to delete this {{name}}? This action cannot be undone.",
  "rk.resource.deleteConfirmTitle": "Delete {{name}}",
  "rk.resource.deleteFailed": "Delete Failed",
  "rk.resource.deleted": "Deleted",
  "rk.resource.deletedSuccess": "{{name}} deleted successfully",
  "rk.resource.details": "Details",
  "rk.resource.discardConfirm": "Discard",
  "rk.resource.discardMessage": "You have unsaved changes. Close without saving?",
  "rk.resource.discardTitle": "Discard changes?",
  "rk.resource.editField": "Edit {{field}}",
  "rk.resource.enterField": "Enter {{field}}",
  "rk.resource.errorLoading": "Error loading {{name}}",
  "rk.resource.filtersDropped": "Some filters ({{fields}}) are not supported by the server and were not applied — the list below is not filtered by them.",
  "rk.resource.keepEditing": "Keep editing",
  "rk.resource.loadingRecord": "Loading record...",
  "rk.resource.openFullPage": "Open full page",
  "rk.resource.other": "Other",
  "rk.resource.proceedWith": "Proceed with {{count}} items?",
  "rk.resource.quickFilter.all": "All",
  "rk.resource.recordNotFound": "Record not found",
  "rk.resource.relation.clear": "Clear {{field}}",
  "rk.resource.relation.noMatches": "No matches",
  "rk.resource.rowActionsLabel": "Actions",
  "rk.resource.selectField": "Select {{field}}",
  "rk.resource.somethingWrong": "Something went wrong",
  "rk.resource.tabHasErrors": "Tab contains errors",
  "rk.resource.tryAgain": "Try Again",
  "rk.resource.unexpectedError": "An unexpected error occurred while rendering this component.",
  "rk.resource.updated": "Updated",
  "rk.resource.updatedSuccess": "{{name}} updated successfully",
  "rk.resource.validation.invalidDate": "Enter a valid date.",
  "rk.resource.validation.invalidEnum": "Select a valid option.",
  "rk.resource.validation.invalidField": "Enter a valid value.",
  "rk.resource.validation.invalidJson": "Enter valid JSON.",
  "rk.resource.validation.invalidNumber": "Enter a valid number.",
  "rk.resource.validation.recordLevel": "Cannot save: {{message}}",
  "rk.resource.validation.required": "This field is required.",
  "rk.schema.invalidJson": "Invalid JSON",
  "rk.schema.items": "{{count}} items",
  "rk.schema.keys": "{{count}} keys",
  "rk.sheet.close": "Close",
  "rk.table.clearFilters": "Clear filters",
  "rk.table.columns": "Columns",
  "rk.table.export": "Export",
  "rk.table.exportAllFailed": "Export failed",
  "rk.table.exportCsvAll": "Export all data (CSV)",
  "rk.table.exportCsvSelected": "Export selected (CSV)",
  "rk.table.exportTooLarge": "Too many rows to export (over {{limit}}). Narrow the filter and try again.",
  "rk.table.goToFirstPage": "Go to first page",
  "rk.table.goToLastPage": "Go to last page",
  "rk.table.goToNextPage": "Go to next page",
  "rk.table.goToPrevPage": "Go to previous page",
  "rk.table.layoutCards": "Card view",
  "rk.table.layoutTable": "Table view",
  "rk.table.loading": "Loading...",
  "rk.table.noMatchingResults": "No matching results",
  "rk.table.noResultsFound": "No results found",
  "rk.table.openRecord": "Open details",
  "rk.table.pageOf": "{{page}} / {{total}}",
  "rk.table.perPageOption": "{{count}} / page",
  "rk.table.rowsPerPage": "Rows per page",
  "rk.table.rowsSelected": "{{count}} row(s) selected",
  "rk.table.selectAll": "Select all",
  "rk.table.selectRow": "Select row",
  "rk.table.toggleColumnsLabel": "Toggle column visibility",
  "rk.table.totalRecords_one": "{{total}} record",
  "rk.table.totalRecords_other": "{{total}} records",
  "rk.ui.cancel": "Cancel",
  "rk.ui.copied": "Copied",
  "rk.ui.copy": "Copy",
  "rk.ui.copyFailed": "Copy failed",
  "rk.ui.copyId": "Copy ID",
  "rk.ui.create": "Create",
  "rk.ui.delete": "Delete",
  "rk.ui.edit": "Edit",
  "rk.ui.error": "An error occurred",
  "rk.ui.idCopied": "ID copied",
  "rk.ui.loading": "Loading...",
  "rk.ui.no": "No",
  "rk.ui.retry": "Retry",
  "rk.ui.save": "Save",
  "rk.ui.saving": "Saving…",
  "rk.ui.search": "Search",
  "rk.ui.yes": "Yes"
}
